import React, { FC, useMemo } from 'react'

import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { isEmpty, map } from 'lodash'
import { Loader, ErrorHandler } from 'components'
import { makeTraceDetails } from 'common'
import { useGetReportsUnderAnalysis } from 'pages/your-personal-data/hooks/useGetReportsUnderAnalysis'

import { NoAvailableReports } from '../no-available-reports/NoAvailableReports'
import { groupedAndSortedReportsByYearAndMonth } from '../utils/functions'
import { ReportsRequestedContainer } from './styles'
import { ReportsYearSection } from '../reports-year-section/ReportsYearSection'

export const ReportsRequested: FC = () => {
  const { userLanguage, privacyCenterContent, isAppError, isAppActive } = useAppContext()

  const { reportsUnderAnalysis, isReportsUnderAnalysisLoading, isReportsUnderAnalysisError } =
    useGetReportsUnderAnalysis()

  const groupedAndSortedReports = useMemo(() => {
    if (!reportsUnderAnalysis || !userLanguage) return undefined

    return groupedAndSortedReportsByYearAndMonth(reportsUnderAnalysis, userLanguage)
  }, [reportsUnderAnalysis, userLanguage])

  const content = privacyCenterContent?.components?.reportsHistory?.content?.requestedReports

  if (isReportsUnderAnalysisLoading)
    return <Loader pxToSubtractFrom100vh={300} message={content?.loadingMessage ?? ''} />

  const isActive = privacyCenterContent?.components?.reportsHistory?.isActive

  const isError = isAppError || isReportsUnderAnalysisError || isEmpty(content)

  const isErrorOrInactive = isError || !isActive || !isAppActive

  if (isErrorOrInactive) {
    const traceDetails = makeTraceDetails(!!isActive, content)

    return <ErrorHandler traceDetails={traceDetails} componentName={ReportsRequested.name} />
  }

  if (isEmpty(reportsUnderAnalysis)) {
    return <NoAvailableReports description={content?.noReportsMessage ?? ''} />
  }

  return (
    <ReportsRequestedContainer>
      {map(groupedAndSortedReports, (reportsByYear, year) => (
        <ReportsYearSection key={year} year={year} reporstByYear={reportsByYear} />
      ))}
    </ReportsRequestedContainer>
  )
}
